import React from "react";
import Errors from "../Errors/Errors";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import FoliosSelect from "../Selects/FoliosSelect";
import numeral from "numeral";

class MoveAmountAppliedForm extends React.Component {
  
  constructor(props) {
    super(props);
  };

  render(){
    return(
      <div className="panel panel-default">
        <div className="panel-body container" style={{paddingTop: '5px'}}>
          <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF' }}>{I18n.t('adjust_applied_amounts')}</h3>
          <Errors errors={this.props.errors} />
          <div className="row">
            {this.renderMaxMoveableAmount()}
            {this.renderMoveAmount()}
            {this.renderFolioSelect()}
          </div>
        </div>
        <LoadingSpinner show={this.props.loading} />
      </div>
    );
  };

  renderMaxMoveableAmount() {
    return (
      <div className="col">
        <label style={{ marginBottom: '10px' }}>{I18n.t('max_to_be_moved')}</label>
        <div>{this.formatCurrency(this.props.paymentLogFolio.paid_to_folio + this.props.paymentLogFolio.refunded_to_folio)}</div>
      </div>
    );
  };

  renderMoveAmount() {
    return (
      <div className="col">
        <label style={{ marginBottom: '10px' }}>{I18n.t('amount_to_move')}</label>
          <CurrencyInput
            name='amount' 
            className="form-control"
            data-min-length="0"
            onChange={this.props.onChangeMoveAmount}
            max={this.maxMoveAmount()}
            min={this.minMoveAmount()}
            value={this.props.moveAmount ? this.props.moveAmount : ''}
          />
      </div>
    );
  };

  renderFolioSelect() {
    return (
      <div className="col">
        <label style={{ marginBottom: '10px' }}>{I18n.t('folio')}</label>
        <FoliosSelect
          folio_id={this.props.paymentLogFolio.folio_id}
          payment_log_id={this.props.payment_log_id}
          onChange={this.props.onChangeFolio}
          callSource={'EditPaymentLog'} />
      </div>
    );
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  maxMoveAmount = () => {
    if(this.props.cashPayment){
      if (this.props.paymentLogFolio.paid_to_folio > 0){
        return this.props.paymentLogFolio.paid_to_folio 
      } else {
        return 0 
      }
    } else {
      return this.props.paymentLogFolio.paid_to_folio + this.props.paymentLogFolio.refunded_to_folio
    };
  };

  minMoveAmount =() => {
    if (this.props.cashPayment) {
      if (this.props.paymentLogFolio.paid_to_folio < 0) {
        return this.props.paymentLogFolio.paid_to_folio
      } else {
        return 0
      }
    } else {
      return 0 
    }
  }

};

export default MoveAmountAppliedForm